<template>
  <div>
    <div v-if="!isFilesEmpty && !compactMode" class="items-wrapper">
      <item v-for="item in items"
            :key="item.id"
            :readonly="readonly"
            :file="item"
            :direct-download="filesDirectDownload"
            @delete="handleDeleteFile"
            @click="handleFileClick"/>
    </div>
    <div v-if="!isFilesEmpty && compactMode" class="items-wrapper">
      <compact-item v-for="item in items"
            class="mr-4"
            :key="item.id"
            :readonly="readonly"
            :file="item"
            :direct-download="filesDirectDownload"
            @delete="handleDeleteFile"
            @click="handleFileClick"/>
    </div>
    <slot v-else name="no-items"></slot>
  </div>

</template>

<script>
import Item from './Item'
import CompactItem from './CompactItem'

export default {
  name: 'List',
  props: {
    items: Array,
    readonly: Boolean,
    filesDirectDownload: Boolean,
    compactMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Item,
    CompactItem
  },
  computed: {
    isFilesEmpty() {
      return !this.items || this.items.length === 0
    }
  },
  methods: {
    handleDeleteFile(fileId) {
      this.$emit('delete', fileId)
    },
    handleFileClick(fileData) {
      this.$emit('fileClick', fileData)
    }
  }
}
</script>

<style scoped>
  .items-wrapper {
    display:flex;
    flex-wrap: wrap;
  }
</style>